import './AppLinks.scss';

type AppLinksProps = {
    androidAppId: string;
    iOSAppId: string;
};

export const AppLinks = ({ androidAppId, iOSAppId }: AppLinksProps) => {
    return (
        <div className="app-links d-flex flex-wrap justify-content-center">
            <a href={`https://apps.apple.com/se/app/id${iOSAppId}`} className="app-link">
                <img src="/images/app-store-badge.png" alt="Hämta i App Store" />
            </a>
            <a href={`https://play.google.com/store/apps/details?id=${androidAppId}`} className="app-link">
                <img src="/images/google-play-badge.png" alt="Ladda ner på Google Play" />
            </a>
        </div>
    );
};
